var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V8.66667C13.9997 8.67437 13.9984 8.682 13.996 8.68933C13.9941 8.69542 13.9928 8.70167 13.992 8.708C13.9882 8.76679 13.9768 8.82484 13.958 8.88067L13.952 8.89867C13.9475 8.91372 13.9419 8.92842 13.9353 8.94267C13.9031 9.0153 13.8579 9.08148 13.802 9.138L9.13533 13.8047C9.01099 13.929 8.84254 13.9993 8.66667 14ZM3.33333 3.33333V12.6667H8V8.66667C8 8.29848 8.29848 8 8.66667 8H12.6667V3.33333H3.33333ZM9.33333 9.33333V11.7247L11.724 9.33333H9.33333Z",
    fill: "#42455F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityNote);
export default __webpack_public_path__ + "static/media/activity-note.2243774e.svg";
export { ForwardRef as ReactComponent };